import Item from "../game/Item";
import Equipment from "../game/Equipment";

export const items = [
  new Item({
    id: "slime",
    name: "Slime",
    type: "Material",
    equipable: false,
  }),

  new Equipment({
    id: "bronzeHelmet",
    name: "Bronze Helmet",
    image: "helmet-common.png",
    type: "Head",
    equipable: true,
    defense: 1,
  }),

  new Equipment({
    id: "bronzeGauntlets",
    name: "Bronze Gauntlets",
    image: "gauntlet-common.png",
    type: "Arms",
    equipable: true,
    defense: 1,
  }),

  new Equipment({
    id: "bronzeChestplate",
    name: "Bronze Chestplate",
    image: "chestplate-common.png",
    type: "Chest",
    equipable: true,
    defense: 2,
  }),

  new Equipment({
    id: "bronzeGreeves",
    name: "Bronze Greeves",
    image: "greeves-common.png",
    type: "Feet",
    equipable: true,
    defense: 1,
  }),

  new Equipment({
    id: "bronzeGreatsword",
    name: "Bronze Greatsword",
    image: "greatsword-common.png",
    type: "Two Hand",
    equipable: true,
    minAttack: 9,
    maxAttack: 12,
    defense: -2,
  }),

  new Equipment({
    id: "bronzeSword",
    name: "Bronze Sword",
    image: "sword-common.png",
    type: "Main Hand",
    equipable: true,
    minAttack: 5,
    maxAttack: 6,
  }),

  new Equipment({
    id: "bronzeDagger",
    name: "Bronze Dagger",
    image: "dagger-common.png",
    type: "Off Hand",
    equipable: true,
    minAttack: 3,
    maxAttack: 4,
  }),

  new Equipment({
    id: "bronzeAxe",
    name: "Bronze Axe",
    image: "axe-common.png",
    type: "Main Hand",
    equipable: true,
    minAttack: 4,
    maxAttack: 9,
  }),

  new Equipment({
    id: "bronzeShield",
    name: "Bronze Shield",
    image: "shield-common.png",
    type: "Off Hand",
    equipable: true,
    defense: 3,
  }),

  new Equipment({
    id: "ironHelmet",
    name: "Iron Helmet",
    type: "Head",
    equipable: true,
    defense: 1,
  }),

  new Equipment({
    id: "ironGauntlets",
    name: "Iron Gauntlets",
    type: "Arms",
    equipable: true,
    defense: 1,
  }),

  new Equipment({
    id: "ironChestplate",
    name: "Iron Chestplate",
    type: "Chest",
    equipable: true,
    defense: 2,
  }),

  new Equipment({
    id: "ironGreeves",
    name: "Iron Greeves",
    type: "Feet",
    equipable: true,
    defense: 1,
  }),

  new Equipment({
    id: "ironGreatsword",
    name: "Iron Greatsword",
    type: "Two Hand",
    equipable: true,
    minAttack: 10,
    maxAttack: 12,
  }),

  new Equipment({
    id: "ironSword",
    name: "Iron Sword",
    image: "sword-rare.png",
    type: "Main Hand",
    equipable: true,
    minAttack: 14,
    maxAttack: 18,
  }),

  new Equipment({
    id: "ironDagger",
    name: "Iron Dagger",
    type: "Off Hand",
    equipable: true,
    minAttack: 3,
    maxAttack: 4,
  }),

  new Equipment({
    id: "ironAxe",
    name: "Iron Axe",
    type: "Main Hand",
    equipable: true,
    minAttack: 3,
    maxAttack: 8,
  }),

  new Equipment({
    id: "ironShield",
    name: "Iron Shield",
    type: "Off Hand",
    equipable: true,
    defense: 3,
  }),

  new Equipment({
    id: "steelSword",
    name: "Steel Sword",
    image: "sword-epic.png",
    type: "Main Hand",
    equipable: true,
    minAttack: 35,
    maxAttack: 43,
  }),
];
